import { Home, Truck, FileText, Pause, XCircle } from 'react-feather'
import pages from './pages'

const operatorNavigation = [
  {
    id: 'operatorDashboard',
    title: 'Dashboard',
    icon: <Home size={20} />,
    navLink: '/bus-operator-portal/dashboard',
    action: 'read',
    resource: 'OperatorDashboard'
  },
  {
    id: 'routeApplications',
    title: 'Route Applications',
    icon: <FileText size={20} />,
    action: 'read',
    resource: 'OperatorRouteApplications',
    children: [
      {
        id: 'routeApplicationsApply',
        title: 'Apply',
        navLink: '/bus-operator-portal/route-applications/apply',
        action: 'manage',
        resource: 'OperatorRouteApplications'
      },
      {
        id: 'routeApplicationsNew',
        title: 'In Progress',
        navLink: '/bus-operator-portal/route-applications/new',
        action: 'manage',
        resource: 'OperatorRouteApplications'
      },
      {
        id: 'routeApplicationsPastApplications',
        title: 'History',
        navLink: '/bus-operator-portal/route-applications/past-applications',
        action: 'read',
        resource: 'OperatorRouteApplications'
      },
      {
        id: 'routeApplicationsDetailsHidden',
        title: '',
        navLink: '/bus-operator-portal/route-applications/details',
        action: 'hidden',
        resource: 'Hidden'
      }
    ]
  },
  {
    id: 'busInspections',
    title: 'Bus Inspections',
    icon: <Truck size={20} />,
    action: 'read',
    resource: 'OperatorBusInspections',
    children: [
      {
        id: 'busInspectionsApply',
        title: 'Apply',
        navLink: '/bus-operator-portal/bus-inspections/apply',
        action: 'manage',
        resource: 'OperatorBusInspections'
      },
      {
        id: 'busInspectionsNew',
        title: 'In Progress',
        navLink: '/bus-operator-portal/bus-inspections/new',
        action: 'manage',
        resource: 'OperatorBusInspections'
      },
      {
        id: 'busInspectionsPastApplications',
        title: 'History',
        navLink: '/bus-operator-portal/bus-inspections/past-applications',
        action: 'read',
        resource: 'OperatorBusInspections'
      },
      {
        id: 'busInspectionsDetailsHidden',
        title: '',
        navLink: '/bus-operator-portal/bus-inspections/details',
        action: 'hidden',
        resource: 'Hidden'
      }
    ]
  },
  {
    id: 'routePermits',
    title: 'Route Permits',
    icon: <FileText size={20} />,
    action: 'read',
    resource: 'OperatorRoutePermits',
    children: [
      {
        id: 'routePermitsApply',
        title: 'Apply',
        navLink: '/bus-operator-portal/route-permits/apply',
        action: 'manage',
        resource: 'OperatorRoutePermits'
      },
      {
        id: 'routePermitsNew',
        title: 'In Progress',
        navLink: '/bus-operator-portal/route-permits/new',
        action: 'manage',
        resource: 'OperatorRoutePermits'
      },
      {
        id: 'routePermitsPastApplications',
        title: 'History',
        navLink: '/bus-operator-portal/route-permits/past-applications',
        action: 'read',
        resource: 'OperatorRoutePermits'
      },
      {
        id: 'routePermitsDetailsHidden',
        title: '',
        navLink: '/bus-operator-portal/route-permits/details',
        action: 'hidden',
        resource: 'Hidden'
      }
    ]
  },
  {
    id: 'routeSuspensions',
    title: 'Route Suspensions',
    icon: <Pause size={20} />,
    action: 'read',
    resource: 'OperatorRouteSuspensions',
    children: [
      {
        id: 'routeSuspensionsApply',
        title: 'Apply',
        navLink: '/bus-operator-portal/route-suspensions/apply',
        action: 'manage',
        resource: 'OperatorRouteSuspensions'
      },
      {
        id: 'routeSuspensionsNew',
        title: 'In Progress',
        navLink: '/bus-operator-portal/route-suspensions/new',
        action: 'manage',
        resource: 'OperatorRouteSuspensions'
      },
      {
        id: 'routeSuspensionsPastApplications',
        title: 'History',
        navLink: '/bus-operator-portal/route-suspensions/past-applications',
        action: 'read',
        resource: 'OperatorRouteSuspensions'
      },
      {
        id: 'routeSuspensionsDetailsHidden',
        title: '',
        navLink: '/bus-operator-portal/route-suspensions/details',
        action: 'hidden',
        resource: 'Hidden'
      }
    ]
  },
  {
    id: 'routeCancellations',
    title: 'Route Cancellations',
    icon: <XCircle size={20} />,
    action: 'read',
    resource: 'OperatorRouteCancellations',
    children: [
      {
        id: 'routeCancellationsApply',
        title: 'Apply',
        navLink: '/bus-operator-portal/route-cancellations/apply',
        action: 'manage',
        resource: 'OperatorRouteCancellations'
      },
      {
        id: 'routeCancellationsNew',
        title: 'In Progress',
        navLink: '/bus-operator-portal/route-cancellations/new',
        action: 'manage',
        resource: 'OperatorRouteCancellations'
      },
      {
        id: 'routeCancellationsPastApplications',
        title: 'History',
        navLink: '/bus-operator-portal/route-cancellations/past-applications',
        action: 'read',
        resource: 'OperatorRouteCancellations'
      },
      {
        id: 'routeCancellationsDetailsHidden',
        title: '',
        navLink: '/bus-operator-portal/route-cancellations/details',
        action: 'hidden',
        resource: 'Hidden'
      }
    ]
  }
]

export default [...operatorNavigation, ...pages]
